import { ScannedCode } from '@/utils/scannedCode';
import { ValidateShippingBatchItem } from '../../models';

export interface BulkValidationResult {
  code: string;
  success: boolean;
  number?: number;
  reason?: string;
}

type ValidateBatchFn = (codes: string[]) => Promise<ValidateShippingBatchItem[]>;

const MAX_CODES_PER_REQUEST = 500;

const buildChunks = (entries: ScannedCode[]): string[][] => {
  const codes = entries.map((entry) => entry.code);
  const chunks: string[][] = [];
  for (let i = 0; i < codes.length; i += MAX_CODES_PER_REQUEST) {
    chunks.push(codes.slice(i, i + MAX_CODES_PER_REQUEST));
  }
  return chunks;
};

export const validateBulkEntries = async (
  entries: ScannedCode[],
  validateBatch: ValidateBatchFn,
  onProgress: (done: number, total: number) => void
): Promise<BulkValidationResult[]> => {
  const chunks = buildChunks(entries);
  const resultsByCode = new Map<string, BulkValidationResult>();
  let done = 0;

  await Promise.all(
    chunks.map(async (codes) => {
      try {
        const items = await validateBatch(codes);
        items.forEach((item) => {
          resultsByCode.set(item.code, {
            code: item.code,
            success: item.success,
            number: item.number,
            reason: item.message,
          });
        });
      } catch (err) {
        const error = err as { data?: { message?: string }; message?: string };
        const reason = error.data?.message || error.message || 'Error al validar el lote';
        codes.forEach((code) => {
          resultsByCode.set(code, { code, success: false, reason });
        });
      }
      done += 1;
      onProgress(done, chunks.length);
    })
  );

  return entries.map((entry) => {
    const found = resultsByCode.get(entry.code);
    return (
      found ?? {
        code: entry.code,
        success: false,
        reason: 'No se recibió respuesta de validación para este código',
      }
    );
  });
};
